import React from 'react';
import {
  Button,
  Accordion,
  AccordionItem,
  Box,
  Flex,
} from '@tapresearch/ui/components';
import { Virtuoso } from 'react-virtuoso';

interface OtherAnswersAccordionProps {
  otherAnswers: string[];
}
export const OtherAnswersAccordion = ({
  otherAnswers,
}: OtherAnswersAccordionProps) => {
  return (
    <Flex align="flex-start" mb="15px">
      <Accordion flexGrow={1}>
        <AccordionItem
          itemTitle={`See "Other" free-text answers`}
          _buttonStyle={{
            as: Button,
            variant: 'subtle',
            fontWeight: 'medium',
            fontSize: 'sm',
            colorScheme: 'blue',
            borderRadius: 'base',
            _hover: {
              bg: 'blue.50',
            },
          }}
        >
          <Virtuoso
            style={{ height: '400px' }}
            totalCount={otherAnswers.length}
            itemContent={(index) => (
              <Box
                borderBottom="1px solid"
                borderColor="gray.200"
                py={5}
                px={2}
              >
                {otherAnswers[index]}
              </Box>
            )}
          />
        </AccordionItem>
      </Accordion>
    </Flex>
  );
};
